import { Entity } from '@backstage/catalog-model';
import { MS_DEFENDER_SUBSCRIPTION_ANNOTATION } from '@zeiss/plugin-ms-defender-common';

export const isMSDefenderAvailable = (entity: Entity) => 
    Boolean(entity.metadata.annotations?.[MS_DEFENDER_SUBSCRIPTION_ANNOTATION]);